module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image25.64fe18e6.jpg";